import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=252b4856&scoped=true"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"
import style0 from "./statement.vue?vue&type=style&index=0&id=252b4856&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b4856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252b4856')) {
      api.createRecord('252b4856', component.options)
    } else {
      api.reload('252b4856', component.options)
    }
    module.hot.accept("./statement.vue?vue&type=template&id=252b4856&scoped=true", function () {
      api.rerender('252b4856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/statement.vue"
export default component.exports